export enum BriefStatus {
  REVIEW_EDITS = 'Review Edits',
  AGREED = 'Agreed',
  WAITING_FOR_AGREEMENT = 'Waiting for Agreement',
  CANCELED = 'Canceled',
}
